<div class="input_control">
  <label [for]="fieldName">
    {{ label }}
  </label>
  <div class="dropdown">
    <button
      nz-button
      nzNoAnimation
      nz-dropdown
      type="button"
      nzTrigger="click"
      (click)="captureClickEvent()"
      (blur)="checkIfFieldHasNotValueAndMarkAsTouched()"
      [nzDropdownMenu]="menu"
      class="dropdown-button"
      [class.danger]="control.invalid && control.touched">
    
      <div class="mr-2">
        <app-flag-component [icon]="controlCountry.value"></app-flag-component>
        <div class="placeholder-country">{{controlCountry.value}}</div>
      </div>
      <img class="arrow-down-icon"
        [class.active]="arrowOpen"
        src="assets/icons/arrow-down.svg" 
        alt="seta de expansão"
      >
    </button>
 
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item
          *ngFor="let option of flagOptions" 
          (click)="selectOption(option.prefix)">
          <div class="option-item">
            <app-flag-component [icon]="option.prefix"></app-flag-component>
            <div class="option-item__prefix">{{option.prefix}}</div>
          </div>
        </li>
      </ul>
    </nz-dropdown-menu>

    <input
      [class.danger]="control.invalid && control.touched"
      [placeholder]="phoneMask"
      [formControl]="control"
      [id]="fieldName"
      [mask]="phoneMask"
      (keyup)="onPhoneChanged($event)"
    >
  </div>

  <app-valid-msg
    [control]="control"
    [hint]="hint"
    [fieldName]="fieldName"
    [showIcon]="showIcon">
  </app-valid-msg>
  
</div>
